export const normalizeFilterValue = (obj) => {
  // possible structures:
  // type and low and high for range
  // no type and rangeLow and rangeHigh for range, string for value

  if (obj.type === 'range') {
    return `range::${JSON.stringify({
      low: obj.low,
      high: obj.high,
    })}`;
  } else if (obj.type) {
    return `${obj.type}::${obj.value}`;
  } else if (obj.rangeLow && obj.rangeHigh) {
    return `range::${JSON.stringify({
      low: obj.rangeLow,
      high: obj.rangeHigh,
    })}`;
  } else if (typeof obj === 'string') {
    return `value::${obj}`;
  }
};

// merge items from multiple arrays, wrap them in a div and join them together
const prepareMerchandisingContentArrays = (type, ...arrs) => {
  return arrs
    .filter((arr) => Array.isArray(arr))
    .flat()
    .map(
      (item) =>
        `<div class="products-browser-banner products-browser-banner--${type}">${
          item?.value || item
        }</div>`
    )
    .join('\n');
};

export const prepareMerchandisingContent = (content) => {
  return {
    top: prepareMerchandisingContentArrays(
      'top',
      content.header,
      content.banner
    ),
    bottom: prepareMerchandisingContentArrays('bottom', content.footer),
    left: prepareMerchandisingContentArrays('left', content.left),
    /*
      1. convert array of items that include position to object with position as key
      and array of items as value
      2. convert object values from array to string
    */
    inline: Object.fromEntries(
      Object.entries(
        (content.inline || []).reduce((acc, item) => {
          const { index } = item.config.position;
          acc[index] = acc[index] || [];
          acc[index].push(prepareMerchandisingContentArrays('inline', [item]));
          return acc;
        }, {})
      ).map(([key, value]) => [key, value.join('\n')])
    ),
  };
};

export const isQueryFilterEssential = (key) => {
  return (
    key.startsWith('filter.') ||
    key.startsWith('sort.') ||
    key === 'q' ||
    key === 'page'
  );
};
